// src/components/TotalValueSection.tsx
import React from 'react';
import { formatCurrency } from '@/common/helpers/mask.helpers';
import InputMoney from '@/common/components/form/CurrencyInputFormik';

interface TotalValueSectionProps {
  totalValue: number;
  enableManualEdit: boolean;
  onEnableEditChange: (enabled: boolean) => void;
}

export const TotalValueSection: React.FC<TotalValueSectionProps> = ({
  totalValue,
  enableManualEdit,
  onEnableEditChange
}) => {
  return (
    <section id="total-debit-section">
      <div className="mt-6 p-4 bg-gray-50 rounded-lg border">
        <h3 className="text-lg font-medium text-gray-900 mb-4">
          Valor Total a Cobrar
        </h3>

        <div className="space-y-4">
          {/* Valor total calculado */}
          <div className="bg-white p-3 rounded border">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Valor Total Calculado
            </label>
            <div className="text-lg font-semibold text-gray-900">
              {formatCurrency(totalValue || 0)}
            </div>
            <p className="text-xs text-gray-500 mt-1">
              Soma automática dos itens selecionados na tabela
            </p>
          </div>

          {/* Checkbox */}
          <div className="flex items-center space-x-2">
            <input
              type="checkbox"
              id="enableEdit"
              checked={enableManualEdit}
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              onChange={(e) => onEnableEditChange(e.target.checked)}
            />
            <label htmlFor="enableEdit" className="text-sm font-medium text-gray-700">
              Ajustar valor final
            </label>
          </div>

          {/* Campo de edição */}
          {enableManualEdit && (
            <div className="max-w-xs">
              <InputMoney
                name="paymentInfo.totalValueEdited"
                label="Valor Total Editado (R$)"
                placeholder="0,00"
                className="text-lg font-medium"
              />
              <p className="mt-2 text-sm text-amber-600">
                ⚠️ Valor editado manualmente - verifique se está correto
              </p>
            </div>
          )}
        </div>

        <p className="mt-3 text-sm text-gray-600">
          O valor final será cobrado do locatário conforme as políticas de cobrança
        </p>
      </div>
    </section>
  );
};